import { useCallback } from "react";
import { SquiggleItem } from "../types/types";
import backend from "../backend";

export const useItemSettingsGlue = (
  adventureId: string,
  refreshAll: () => void
) => {
  const setIgnoreCanonicalName = useCallback((item: SquiggleItem, ignore: boolean) => {
    (async () => {
      const response = await backend.setIgnoreCanonicalName(adventureId, item.id, ignore);
      if (!response.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  const setCaseSensitiveNames = useCallback((item: SquiggleItem, caseSensitive: boolean) => {
    (async () => {
      const response = await backend.setCaseSensitiveNames(adventureId, item.id, caseSensitive);
      if (!response.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  return { setIgnoreCanonicalName, setCaseSensitiveNames };
};